import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-57abcef4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  "class": "pre_error_wrap"
};
var _hoisted_2 = {
  "class": "pre_error"
};
var _hoisted_3 = {
  "class": "pre_error_text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1)])])) : _createCommentVNode("", true);
}